import * as actionTypes from '../store/action-types';
import { ProductSelection } from 'components/ProductsSelection/types';
import { GroupType } from 'utils/types';

type StateType = {
  readonly currentStep: number;
  readonly error: string;
  readonly groupId: string;
  readonly groupName: string;
  readonly groupType: GroupType;
  readonly show: boolean;
  readonly showEdit: boolean;
  readonly selection: ProductSelection;
};

const initialState: StateType = {
  currentStep: 1,
  error: '',
  groupId: null,
  groupName: '',
  groupType: 'store',
  show: false,
  showEdit: false,
  selection: {
    accounts: [],
    states: [],
    stores: [],
    items: [],
  },
};

const addLabelToItem = (item) => ({
  id: item,
  label: item,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ERROR_SET:
      return {
        ...state,
        error: action.payload,
      };

    case actionTypes.SET_GROUP:
      return {
        ...state,
        selection: {
          accounts: action.payload.accounts?.map(addLabelToItem),
          states: action.payload.states?.map(addLabelToItem),
          stores: action.payload.stores?.map(addLabelToItem),
          items: action.payload.items?.map(addLabelToItem),
        },
      };

    case actionTypes.CURRENT_STEP_SET:
      return {
        ...state,
        currentStep: action.payload,
      };

    case actionTypes.STORE_GROUP_APPLY_BY_SECTION:
      return {
        ...state,
        selection: {
          ...state.selection,
          [action.payload.currentMenu]: [...action.payload.values],
        },
      };

    case actionTypes.ITEM_GROUP_APPLY:
      return {
        ...state,
        selection: {
          ...state.selection,
          items: [...action.payload],
        },
      };

    case actionTypes.GROUP_NAME_CHANGE:
      return {
        ...state,
        groupName: action.payload,
      };

    case actionTypes.GROUP_TYPE_SET:
      return {
        ...state,
        groupType: action.payload,
      };

    case actionTypes.MOVE:
      return {
        ...state,
        currentStep: action.payload,
        error: initialState.error,
      };

    case actionTypes.OPEN:
      return {
        ...state,
        currentStep: initialState.currentStep,
        error: initialState.error,
        groupName: initialState.groupName,
        groupType: initialState.groupType,
        show: true,
        selection: { ...initialState.selection },
      };

    case actionTypes.OPEN_EDIT:
      return {
        ...state,
        currentStep: 2,
        error: initialState.error,
        groupId: action.payload.groupId,
        groupName: initialState.groupName,
        groupType: action.payload.groupType,
        show: true,
        selection: { ...initialState.selection },
      };

    case actionTypes.SAVE_REQUEST:
      return {
        ...state,
        error: initialState.error,
        currentStep: initialState.currentStep,
      };

    case actionTypes.RESET:
      return {
        ...state,
        groupId: null,
        selection: { ...initialState.selection },
      };

    case actionTypes.SHOW:
      return {
        ...state,
        show: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
